import { render, staticRenderFns } from "./EchartsBarChart.vue?vue&type=template&id=96fe1646&"
import script from "./EchartsBarChart.vue?vue&type=script&lang=js&"
export * from "./EchartsBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports